import { isNullOrUndefined } from "et3-type-guards";
import React from "react";

export const backToTop = (scrolledDiv: React.RefObject<HTMLDivElement>) => {
  if (!isNullOrUndefined(scrolledDiv.current)) {
    window.scrollTo(0, 0);
    scrolledDiv.current.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }
};
